export default __webpack_public_path__ + "navigation-examples-custom-waypoint-thumbnail-960-56ae07d2b3b92f5b2171b81811ac0e7b.png";